import React from "react";
import QueryString from "query-string";
import AppState from "./model/AppState";
import ObaTextField from "./components/ObaTextField";
import LogUtil from "./util/LogUtil";
import { FormControl, Snackbar } from "@material-ui/core";
import C5UsuarioDAO from "./dataAccess/C5/C5UsuarioDAO";
import UsuarioLoginModel from "./model/UsuarioLoginModel";
import NavegadorUtil from "./util/NavegadorUtil";
import UsuarioModel from "./model/UsuarioModel";
import AlertaModel from "./model/AlertaModel";
import ObaUsuarioDAO from "./dataAccess/Oba/ObaUsuarioDAO";
import ObaUsuarioCadastroModel from "./model/ObaUsuarioCadastroModel";
import Carregando from "./components/Carregando";
import { ReactComponent as ImagemMenuBack } from "./assets/images/icons/menu-back.svg";
import Rodape from "./components/Rodape";
import { withRouter, RouteComponentProps, Link } from "react-router-dom";

interface ILoginProps extends RouteComponentProps {}

type LoginState = {
  email: string;
  senha: string;
  carregando: boolean;
  concluido: boolean;
};

class Login extends React.Component<ILoginProps, LoginState> {
  constructor(props: ILoginProps) {
    super(props);

    this.login = this.login.bind(this);

    this.state = {
      email: "",
      senha: "",
      carregando: false,
      concluido: false,
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Login");

    const query: any = QueryString.parse(this.props.location.search);

    if (AppState.getUsuarioLogado() !== null) {
      if (query.returnUrl && query.returnUrl.length > 0) {
        NavegadorUtil.redirect(query.returnUrl, this.props.history);
      }
    }
  }

  login(): void {
    const { email, senha } = this.state;
    const usuario: UsuarioLoginModel = {
      email,
      senha,
    } as UsuarioLoginModel;
    this.setState({ carregando: true });
    C5UsuarioDAO.getInstance()
      .logarUsuario(usuario)
      .then((u: any) => {

        let documentoTratado: string = u.data.DocumentNumber;
        documentoTratado = documentoTratado.padStart(11, "0");

        C5UsuarioDAO.getInstance()
          .buscaUsuarioEndereco(u.data.ClientID)
          .then(async (eId) => {

            ObaUsuarioDAO.getInstance()
              .getUsuario(usuario.email)
              .then(async (uOba: ObaUsuarioCadastroModel) => {
                if (u != null && u.CodigoOba !== 0) {
                  AppState.setUsuarioLogado({
                    email: usuario.email,
                    clienteId: u.data.ClientID,
                    clienteEnderecoId: eId,
                    cep: uOba.CEP,
                    nome: u.data.Name,
                    documento: documentoTratado,
                    sexo: u.data.Gender,
                    telefone: u.data.PhoneNumber,
                    nascimento: u.data.BirthDate,
                  } as UsuarioModel);
                } else {
                  AppState.setUsuarioLogado({
                    email: u.data.Email,
                    clienteId: u.data.ClientID,
                    clienteEnderecoId: eId,
                    documento: documentoTratado,
                    sexo: u.data.Gender,
                    telefone: u.data.PhoneNumber,
                    nascimento: u.data.BirthDate,
                    nome: u.data.Name,
                  } as UsuarioModel);
                }
                AppState.setMaioridade(false);

                if (eId > 0) {
                  const end = await C5UsuarioDAO.getInstance().buscaUsuarioEnderecoCompleto(+u.data.ClientID);
    
                  if (!end || !end.complemento || end.complemento.length === 0) {
                    NavegadorUtil.alerta(this,
                      "Favor confirmar seus dados de endereço e salvar seu cadastro novamente, aceitando os termos e condições");
                    NavegadorUtil.redirect("/cadastre-se", this.props.history);
                    this.setState({ carregando: false, concluido: true });
                    return;
                  }
                }
    
                this.setState({ carregando: false });

                const query: any = QueryString.parse(
                  this.props.location.search
                );
                if (query.returnUrl && query.returnUrl.length > 0) {
                  NavegadorUtil.redirect(query.returnUrl, this.props.history);
                } else {
                  if (AppState.getLojaSelecionada() !== null) {
                    NavegadorUtil.redirect("/home", this.props.history);
                  } else {
                    NavegadorUtil.redirect("/lojas", this.props.history);
                  }
                }
              })
              .catch((err: any) => {
                NavegadorUtil.alerta(
                  this,
                  `Erro ao carregar dados do usuário [${JSON.stringify(err)}] .`
                );
                this.setState({ carregando: false, concluido: true });
              });
          })
          .catch((err: any) => {
            ObaUsuarioDAO.getInstance()
              .getUsuario(usuario.email)
              .then((uOba: ObaUsuarioCadastroModel) => {
                AppState.setUsuarioLogado({
                  email: usuario.email,
                  clienteId: u.data.ClientID,
                  clienteEnderecoId: 0,
                  cep: uOba.CEP,
                  nome: u.data.Name,
                  documento: documentoTratado,
                  sexo: u.data.Gender,
                  telefone: u.data.PhoneNumber,
                  nascimento: u.data.BirthDate,
                } as UsuarioModel);

                NavegadorUtil.alerta(this,
                  "Favor confirmar seus dados de endereço e salvar seu cadastro novamente, aceitando os termos e condições");
                this.setState({ carregando: false });
                NavegadorUtil.redirect("/cadastre-se", this.props.history);
              }).catch(() => {
                NavegadorUtil.alerta(
                  this,
                  `Erro ao carregar dados do usuário [end: ${JSON.stringify(err)}] .`
                );
                this.setState({ carregando: false, concluido: true });
              });

          });
      })
      .catch((err: any) => {
        NavegadorUtil.alerta(
          this,
          "Usuário não localizado com este email e senha."
        );
        this.setState({ carregando: false, concluido: true });
      });
  }

  render(): any {
    const { email, senha, carregando, concluido } = this.state;
    const fieldWidth: number = 300;
    const objStyle: any = {
      width: fieldWidth,
      margin: "0 auto",
      display: "block",
      marginTop: 20,
    };
    let alerta: any = AppState.getAlerta();
    let signUpURL: string = NavegadorUtil.getUrl("/cadastre-se");
    const query: any = QueryString.parse(this.props.location.search);
    if (query.returnUrl && query.returnUrl.length > 0) {
      signUpURL += "?returnUrl=" + query.returnUrl;
    }

    if (!alerta) {
      alerta = {
        exibirModal: false,
      } as AlertaModel;
    }

    return (
      <section className="login">
        <div
          className="header"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/img_login.png)`,
          }}
        >
          <div className="back" onClick={() => this.props.history.goBack()}>
            <ImagemMenuBack />
          </div>
        </div>
        <h1>Login</h1>
        <FormControl variant="outlined" style={objStyle}>
          <ObaTextField
            onChange={(e) => this.setState({ email: e.target.value as string })}
            type="email"
            style={{ width: fieldWidth }}
            variant="outlined"
            label="E-mail"
            value={email}
          />
        </FormControl>
        <FormControl variant="outlined" style={objStyle}>
          <ObaTextField
            onChange={(e) => this.setState({ senha: e.target.value as string })}
            type="password"
            style={{ width: fieldWidth }}
            variant="outlined"
            label="Senha"
            value={senha}
          />
        </FormControl>
        <button onClick={this.login}>Entrar</button>
        <div className="subActions">
          <Link to={signUpURL} className="left">
            Cadastre-se
          </Link>
          <Link
            to={NavegadorUtil.getUrl("/esqueci-minha-senha")}
            className="right"
          >
            Esqueci minha senha
          </Link>
        </div>
        <Rodape parent={this} ativo="Menu"></Rodape>
        <Carregando exibir={carregando} concluido={concluido} />
        <Snackbar
          open={alerta.exibirModal}
          className="info"
          transitionDuration={1000}
          onClose={() => AppState.fecharAlerta(this)}
          autoHideDuration={6000}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{alerta.mensagem}</span>}
        />
      </section>
    );
  }
}

export default withRouter(Login);
